import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import _ from 'underscore';
import dynamic from 'next/dynamic';

import { useIsMobile } from 'hooks/useIsMobile';

const MobileControls = dynamic(() => import('./components/MobileControls'), {
	ssr: false
});

const DesktopControls = dynamic(() => import('./components/DesktopControls'), {
	ssr: false
});

const filtersOptions = {
	rubrics: [
		{
			title: 'Кино',
			name: 'cinema'
		},
		{
			title: 'Музеи',
			name: 'museums'
		},
		{
			title: 'Музыка',
			name: 'music'
		},
		{
			title: 'Театры',
			name: 'theaters'
		},
		{
			title: 'Литература',
			name: 'literature'
		},
		{
			title: 'Традиции',
			name: 'traditions'
		},
		{
			title: 'Другие новости культуры',
			name: 'news'
		}
	]
};

const Controls = ({ urlParams, handleFilterChange }) => {
	const isMobile = useIsMobile();
	const { push, pathname } = useRouter();

	const filters = _(urlParams).omit('page');

	const handleFilterReset = useCallback(() => {
		push({ pathname });
	}, [pathname, push]);

	return (
		<>
			{isMobile ? (
				<MobileControls
					onFilterChange={handleFilterChange}
					onFilterReset={handleFilterReset}
					{...{
						filters,
						filtersOptions
					}}
				/>
			) : (
				<DesktopControls
					onFilterChange={handleFilterChange}
					{...{ filters, filtersOptions }}
				/>
			)}
		</>
	);
};

Controls.propTypes = {
	urlParams: PropTypes.object.isRequired,
	handleFilterChange: PropTypes.func
};

export default Controls;
